module.exports = __webpack_public_path__ + "img/affiliate.2cd2c85a.svg";